import { useAtomValue } from 'jotai';
import { isSkipButtonInProgressAtom } from '../player-controls-navigation/skip-buttons';
import { playerWaitingAtom } from '../../atoms';
import { isScrubberDraggingAtom } from '../player-controls-scrubber/player-controls-scrubber-base';

const useDeactivatePlayerActions = () => {
  const isSkipButtonInProgress = useAtomValue(isSkipButtonInProgressAtom);
  const playerWaiting = useAtomValue(playerWaitingAtom);
  const isScrubberDragging = useAtomValue(isScrubberDraggingAtom);
  return isSkipButtonInProgress || playerWaiting || isScrubberDragging;
};

export default useDeactivatePlayerActions;
